module.exports = __webpack_public_path__ + "img/Margo.ffae74e1.jpg";